define('Components/AboutNavByDesireWidget/js/AboutNavByDesireWidget',['hooks',
        'Components/AboutNavByDesireWidget/js/views/AboutNavByDesireWidgetInstanceView',
        'Components/AboutNavByDesireWidget/js/views/EmptyChildView',
        'Components/AboutNavByDesireWidget/js/models/AboutNavByDesireWidgetInstanceModel'
    ],
    function(hooks,
             AboutNavByDesireWidgetInstanceView,
             EmptyChildView,
             AboutNavByDesireWidgetInstanceModel){

        return function(){
            hooks.registerWidgetInstance(
                'AboutNavByDesireWidget',
                {
                    'parent':AboutNavByDesireWidgetInstanceView,
                    'child':EmptyChildView
                },
                AboutNavByDesireWidgetInstanceModel

            );
        }

});
